module.exports = __webpack_public_path__ + "img/icon-edit.4f121579.svg";